<template>
  <div
    class="reason-card-scope overflow-scroll-y"
    v-loading.fullscreen.lock="fullscreenLoading"
    :element-loading-text="loadingText"
  >
    <div class="card-header">
      <h2>志望動機を入力</h2>
      <p v-if="globalVar.isYagiPrime" style="white-space: pre-line">
        {{ reasonLabelYagiprime }}
      </p>
      <p v-else-if="showReasonLabel20240717" style="white-space: pre-line">
        {{ reasonLabel20240717 }}
      </p>
      <p v-else style="white-space: pre-line">{{ reasonLabel }}</p>
    </div>

    <div class="add-item button-block">
      <button
        v-if="globalVar.in_app_payments"
        class="primary-button ai-create-btn"
        @click="showModalFromNewAi"
      >
        <span>AI作成</span>
      </button>
      <el-button
        v-if="formatId != 'rirekisho_esf_challenged'"
        type="success"
        @click="exampleDialogVisible = true"
        >例文を選ぶ</el-button
      >
      <el-button
        icon="el-icon-info"
        circle
        class="proofread-tips-btn"
        @click="tipsDialogVisible = true"
      />
      <el-button icon="el-icon-delete" circle @click="reasonClear" />
    </div>

    <div class="card-content">
      <reason-example-dialog
        :value="exampleDialogVisible"
        :items="exampleSentences.reason || []"
        :ai-generated-example="aiGeneratedExampleReason"
        @input="exampleDialogVisible = $event"
        @select="updateReason"
      />
      <reason-proofread-tips-dialog
        :value="tipsDialogVisible"
        @input="tipsDialogVisible = $event"
      />

      <ai-mypr-dialog
        :visible="aiMyprVisible"
        @update:visible="onAiMyprVisible"
      >
        <div class="ai-mypr-modal-scroll reason-card-scope">
          <div class="v--modal-close-top">
            <el-button
              icon="el-icon-circle-close"
              style="font-size: 2rem; padding: 0"
              type="text"
              @click="closeAiMyprDialog"
            />
          </div>
          <div class="mypr-title-block">
            <p class="mypr-title-catch">1日1回無料</p>
            <h3>AIがあなたの内定を勝ち取る文章を作成</h3>
            <p class="mypr-lead">
              4つの質問に答えるだけで、AIがあなたの『得意なこと』と『企業への熱意』を結びつけます。
            </p>
          </div>
          <div v-if="!aiResultView">
            <reason-ai-mypr-form
              layout="dialog"
              :format-data="formatData"
              :hope-industry-options="hopeIndustryOptions"
              :hope-jobcategory-options="hopeCareerJobcategoryOptions"
              :is-yagi-prime="!!globalVar.isYagiPrime"
              :extracting="isExtractingCompanyInfo"
              :extracted="isCompanyInfoExtracted"
              :licences="getLicences"
              @update-field="onUpdateField"
              @extract="extractCompanyInfo"
              @prime-cta="handleAIMypr"
            />
          </div>
          <div v-else>
            <div
              v-if="aiIsThinking"
              class="ai-thinking"
              @click="aiReasoningText ? toggleAiReasoning() : null"
            >
              <span class="ai-thinking__icon"></span>
              <span class="ai-thinking__label">{{ aiThinkingLabel }}</span>
              <span class="ai-thinking__dots">
                <span class="ai-thinking__dot"></span>
                <span class="ai-thinking__dot"></span>
                <span class="ai-thinking__dot"></span>
              </span>
            </div>
            <div v-if="aiReasoningText">
              <div class="ai-reasoning__toggle" @click="toggleAiReasoning">
                <span
                  class="ai-reasoning__arrow"
                  :class="{ 'ai-reasoning__arrow--open': aiShowReasoning }"
                  >▶</span
                >
                {{ aiShowReasoning ? '思考過程を隠す' : '思考過程を見る' }}
              </div>
              <div
                class="ai-reasoning"
                :class="
                  aiShowReasoning
                    ? 'ai-reasoning--expanded'
                    : 'ai-reasoning--collapsed'
                "
              >
                <div class="ai-reasoning__content">{{ aiReasoningText }}</div>
              </div>
            </div>
            <ul
              v-show="!aiIsThinking"
              class="example-sentence example-sentence--ai-result"
            >
              <li @click="applyAiMyprResult(true)">
                <div class="title">AIからの提案</div>
                <div class="body">
                  <span v-html="aiResultMyprResult"></span
                  ><span
                    v-if="aiIsStreaming && !aiIsThinking"
                    class="ai-cursor"
                  ></span>
                </div>
              </li>
            </ul>
            <div
              v-if="!globalVar.isYagiPrime"
              v-show="!aiIsThinking"
              class="ai-mypr-result-actions"
            >
              <el-button @click="applyAiMyprResult(true)"
                >途中まで使う</el-button
              >
              <el-button
                v-if="globalVar.in_app_payments"
                id="prime-reasonai-register-btn"
                class="ai-mypr-fulltext-btn"
                @click="goYagiprimeRegister"
                >全文を使う</el-button
              >
            </div>
          </div>
          <div
            v-if="globalVar.isYagiPrime"
            v-show="!aiIsStreaming && aiResultView"
            class="ai-mypr-result-actions"
          >
            <el-button @click="toggleAIMyprDialog">もう一度作る</el-button>
            <el-button
              class="ai-mypr-fulltext-btn"
              @click="applyAiMyprResult(true)"
              >全文を使う</el-button
            >
          </div>
        </div>
        <div
          v-if="!aiResultView && globalVar.in_app_payments"
          class="mypr-popup-btnarea ai-mypr-modal-footer"
        >
          <p v-if="globalVar.isYagiPrime" class="count-txt">
            <span>利用回数：</span
            ><span>{{ aiUsageCount }} / {{ aiMaxUsageCount }}回</span>
          </p>
          <el-button
            v-if="!isAuthenticated"
            v-show="!aiIsStreaming"
            @click="openLoginDialog"
          >
            <span>ログインして生成する</span>
          </el-button>
          <el-button
            v-else
            v-show="!aiIsStreaming"
            class="ai-mypr-cta-btn"
            :class="{ 'ai-mypr-cta-btn--locked': aiMyprCtaState === 'locked' }"
            @click="handleAIMypr"
          >
            <span v-if="aiMyprCtaState === 'locked'"
              >🔒 ヤギプライムで無制限に作成する</span
            >
            <span v-else-if="aiMyprCtaState === 'free'"
              >✨ 無料でAI文章を作成する（本日残り1回）</span
            >
            <span v-else>AIで文章作成をする</span>
          </el-button>
          <p
            v-show="!aiIsStreaming && aiMyprCtaState === 'locked'"
            class="ai-mypr-cta-note ai-mypr-cta-note--locked"
          >
            本日の無料回数を使い切りました
          </p>
          <p class="mypr-attention">
            ※例文選択・AI再生成をすると、現在入力中の文章は上書きされます。
          </p>
        </div>
      </ai-mypr-dialog>

      <div class="reason-input-layout">
        <div v-if="globalVar.in_app_payments" class="reason-ai-column">
          <reason-ai-mypr-panel
            :format-data="formatData"
            :hope-industry-options="hopeIndustryOptions"
            :hope-jobcategory-options="hopeCareerJobcategoryOptions"
            :is-yagi-prime="!!globalVar.isYagiPrime"
            :in-app-payments="!!globalVar.in_app_payments"
            :is-authenticated="!!isAuthenticated"
            :extracting="isExtractingCompanyInfo"
            :extracted="isCompanyInfoExtracted"
            :licences="getLicences"
            :ai-usage-count="aiUsageCount"
            :ai-max-usage-count="aiMaxUsageCount"
            :cta-state="aiMyprCtaState"
            :ai-result-view="aiResultView"
            :ai-result-html="aiResultMyprResult"
            :ai-is-streaming="aiIsStreaming"
            :ai-is-thinking="aiIsThinking"
            :ai-thinking-label="aiThinkingLabel"
            :ai-reasoning-text="aiReasoningText"
            :ai-show-reasoning="aiShowReasoning"
            @update-field="onUpdateField"
            @extract="extractCompanyInfo"
            @generate="handleAIMypr"
            @login="openLoginDialog"
            @apply="applyAiMyprResult"
            @register="goYagiprimeRegister"
            @retry="toggleAIMyprDialog"
            @toggle-reasoning="toggleAiReasoning"
          />
          <referral-campaign-banner
            v-if="!globalVar.isYagiPrime"
            class="reason-ai-column__campaign"
            placement="reason_ai_mypr"
            new-tab
          />
        </div>

        <div class="reason-manual-panel">
          <div class="reason-manual-panel-lead">
            <h3>AIがあなたの内定を勝ち取る文章を作成</h3>
            <p class="mypr-lead">
              質問に答えるとAIがあなたの『得意なこと』と『企業への熱意』を結びつけます。<br />また、自分なりの言葉で表現したあと、校正機能も使うことができます。
            </p>
          </div>
          <el-input
            type="textarea"
            v-model="reason"
            v-proofread="{ phase2: true, context: '志望動機' }"
            :autosize="reasonAutosizeSettings"
          />
          <div v-if="globalVar.in_app_payments" class="button-container">
            <button
              v-if="isAuthenticated && isSendMail"
              class="primary-button"
              @click="insertSentence"
            >
              <span>メールの添削文章を挿入</span>
            </button>
          </div>
          <div v-if="previewErrors.reason" class="attention-limit character">
            <i class="el-icon-warning"></i>
            入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
            <div v-if="!summarizePreview.visible" class="summarize-link-row">
              <a
                v-if="globalVar.isYagiPrime"
                class="summarize-link"
                href="javascript:void(0)"
                @click="openSummarizeModal"
              >
                AIで短縮案を見る
              </a>
              <a
                v-else
                class="summarize-link summarize-link-gate"
                href="javascript:void(0)"
                @click="showYagiprimeForSummarize"
              >
                AIで短縮案を見る（ヤギプライム会員限定）
              </a>
            </div>
            <reason-summarize-preview
              :visible="summarizePreview.visible"
              :loading="summarizePreview.loading"
              :rate-limited="summarizePreview.rateLimited"
              :error-message="summarizePreview.errorMessage"
              :first="summarizePreviewFirst"
              :display-text="summarizePreviewDisplayText"
              :original-length="(reason || '').length"
              :is-yagi-prime="!!globalVar.isYagiPrime"
              @close="closeSummarizePreview"
              @open-prime="openYagiprimeFromPreview"
              @apply="applySummarizePreview"
              @open-modal="openSummarizeModal"
            />
          </div>
          <summarize-modal
            v-if="globalVar.isYagiPrime && reason"
            :visible="summarizeModalVisible"
            :text="reason"
            :target-length="summarizeTargetLength"
            :variation-count="3"
            context="志望動機"
            @update:visible="summarizeModalVisible = $event"
            @apply="applySummarize"
          />
        </div>
      </div>
    </div>

    <div v-if="formatId == 'rirekisho_job_change_old'">
      <p class="guidetxt">志望動機の見本（参考にして作成しましょう）</p>
      <img
        src="/static/img/rirekishoguide/guide06.png"
        alt="志望動機"
        class="guideimg"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SummarizeModal from '@/proofreading/phase2/summarize-modal.vue'
import AiMyprDialog from '@/components/format-edit/AiMyprDialog.vue'
import ReasonExampleDialog from '@/components/yagiprime/ReasonExampleDialog.vue'
import ReasonProofreadTipsDialog from '@/components/yagiprime/ReasonProofreadTipsDialog.vue'
import ReasonAiMyprForm from '@/components/yagiprime/ReasonAiMyprForm.vue'
import ReasonAiMyprPanel from '@/components/yagiprime/ReasonAiMyprPanel.vue'
import ReasonSummarizePreview from '@/components/yagiprime/ReasonSummarizePreview.vue'
import ReferralCampaignBanner from '@/components/yagiprime/ReferralCampaignBanner.vue'
import { useReasonAiMypr } from '@/composables/yagiprime/useReasonAiMypr'

const props = defineProps<{
  formatId: string
  exampleSentences: { reason?: Array<{ title: string; description: string }> }
  textareaMinRows: number
  previewErrors: Record<string, unknown>
  formatData: Record<string, unknown>
  currentCardId: string
}>()

const emit = defineEmits<{
  (e: 'update:reason', value: string): void
  (e: 'update-format-field', payload: { key: string; value: unknown }): void
}>()

function updateFormatField(key: string, value: unknown) {
  emit('update-format-field', { key, value })
}

function onUpdateField(payload: { key: string; value: unknown }) {
  updateFormatField(payload.key, payload.value)
}

const api = useReasonAiMypr({
  formatData: props.formatData,
  emit,
  updateFormatField
})

const {
  globalVar,
  isAuthenticated,
  aiMyprVisible,
  closeAiMyprDialog,
  openLoginDialog,
  aiResultView,
  aiResultMyprResult,
  fullscreenLoading,
  loadingText,
  aiGeneratedExampleReason,
  hopeIndustryOptions,
  hopeCareerJobcategoryOptions,
  isSendMail,
  aiUsageCount,
  aiMaxUsageCount,
  isExtractingCompanyInfo,
  isCompanyInfoExtracted,
  exampleDialogVisible,
  tipsDialogVisible,
  summarizeModalVisible,
  summarizePreview,
  aiIsStreaming,
  aiIsThinking,
  aiThinkingLabel,
  aiReasoningText,
  aiShowReasoning,
  toggleAiReasoning,
  reason,
  getLicences,
  aiMyprCtaState,
  summarizeTargetLength,
  summarizePreviewFirst,
  summarizePreviewDisplayText,
  reasonClear,
  updateReason,
  showModalFromNewAi,
  toggleAIMyprDialog,
  extractCompanyInfo,
  handleAIMypr,
  goYagiprimeRegister,
  applyAiMyprResult,
  openSummarizeModal,
  applySummarize,
  closeSummarizePreview,
  openYagiprimeFromPreview,
  applySummarizePreview,
  showYagiprimeForSummarize,
  insertSentence
} = api

function onAiMyprVisible(val: boolean) {
  if (!val) closeAiMyprDialog()
  else aiMyprVisible.value = true
}

const reasonLabels = {
  default:
    '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！',
  jobNew:
    '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
  jobNewSingle:
    '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
  reasonLabel20240717:
    '志望動機を入力してください。 1日1回、無料でAIで文章を生成することができます。\nヤギプライムに加入すると、文章生成が1日10回に上限解放されます。',
  reasonLabelYagiprime: '最新のAIを使って、あなたらしい文章にしましょう！'
}

const reasonLabel = computed(() => {
  if (props.formatId === 'rirekisho_job_new') return reasonLabels.jobNew
  if (props.formatId === 'rirekisho_job_new_single') {
    return reasonLabels.jobNewSingle
  }
  return reasonLabels.default
})
const reasonLabel20240717 = reasonLabels.reasonLabel20240717
const reasonLabelYagiprime = reasonLabels.reasonLabelYagiprime

const legacyReasonLabelFormatIds = [
  'rirekisho_job_change_old',
  'rirekisho_job_change2',
  'rirekisho_single',
  'rirekisho_nophoto_double',
  'rirekisho_nophoto'
] as const

const showReasonLabel20240717 = computed(
  () =>
    !(legacyReasonLabelFormatIds as readonly string[]).includes(props.formatId)
)
const reasonAutosizeSettings = computed(() => {
  const baseRows =
    props.formatId === 'rirekisho_job_change' ? 7 : props.textareaMinRows
  const minRows = Math.max(1, baseRows * 2)
  return { minRows, maxRows: Math.max(minRows, 20) }
})
</script>

<style src="@/assets/css/ai-streaming.css"></style>

<style lang="scss" src="@/assets/scss/yagiprime/reason-card.scss"></style>
